const NewsAdvisory = () => import('@/modules/NewsAdvisory')

export default [
	{
		component: NewsAdvisory,
		meta: {
			context: {}
		},
		name: 'news-advisory',
		path: 'news/:context?'
	}
]
